const urlRelatorios = "/v1/Relatorios";

const service = {
  methods: {
    $obterRelatorioAnaliticoSolicitacaoFormacao(params) {
        return this.$api().get(`${urlRelatorios}/RelatorioDeSolicitacaoFormacao`, params);
    },
    $obterRelatorioAnaliticoPDFSolicitacaoFormacao(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeSolicitacaoFormacaoPdf`, this.$getParamsObject(params));
    },
    $obterRelatorioAnaliticoCSVSolicitacaoFormacao(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeSolicitacaoFormacaoCsv`, params);
    },

    //Relatório de Formações por Gre
    $obterRelatorioSolicitacaoFormacaoPorGre(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorGre`, params);
    },
    $obterRelatorioPDFSolicitacaoFormacaoPorGre(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorGrePdf`, this.$getParamsObject(params));
    },
    $obterRelatorioCSVSolicitacaoFormacaoPorGre(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorGreCsv`, params);
    },

    //Relatório de Formações por Escola
    $obterRelatorioSolicitacaoFormacaoPorEscola(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorEscola`, params);
    },
    $obterRelatorioPDFSolicitacaoFormacaoPorEscola(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorEscolaPdf`, this.$getParamsObject(params));
    },
    $obterRelatorioCSVSolicitacaoFormacaoPorEscola(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorEscolaCsv`, params);
    },

    //Relatório de Formações por Disciplina
    $obterRelatorioAnaliticoFormacoesPorDisciplina(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorDisciplina`, params);
    },
    $obterRelatorioAnaliticoPDFFormacoesPorDisciplina(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorDisciplinaPdf`, this.$getParamsObject(params));
    },
    $obterRelatorioAnaliticoCSVFormacoesPorDisciplina(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorDisciplinaCsv`, params);
    },

    //Relatório de Formações por Funcão
    $obterRelatorioAnaliticoFormacoesPorFuncao(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorFuncao`, params);
    },
    $obterRelatorioAnaliticoPDFFormacoesPorFuncao(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorFuncaoPdf`, this.$getParamsObject(params));
    },
    $obterRelatorioAnaliticoCSVFormacoesPorFuncao(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorFuncaoCsv`, params);
    },
    
    //Relatório de Público Alvo
    $obterRelatorioAnaliticoFormacoesPorPublicoAlvo(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorPublicoAlvo`, params);
    },
    $obterRelatorioAnaliticoPDFFormacoesPorPublicoAlvo(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorPublicoAlvoPdf`, this.$getParamsObject(params));
    },
    $obterRelatorioAnaliticoCSVFormacoesPorPublicoAlvo(params) {
      return this.$api().get(`${urlRelatorios}/RelatorioDeFormacaoPorPublicoAlvoCsv`, params);
    },
  }
};

export default service;